import httpUtils from '../../utils/HttpUtils'

class CancelAppointmentCheckService {

  //业主申请取消预约
  async createCancelAppointment (cancelAppointment) {
    console.log('预约监理、工长、保洁、搬家');
    var result = null;
    try {
      result = await httpUtils.post('/server/cancel/appointment/check/create',cancelAppointment);
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //获取业主最新取消预约审核结果
  async getNewestCancelAppointment (appointmentId = '',customerId = '') {
    var result = null;
    try {
      result = await httpUtils.post('/server/cancel/appointment/check/newest',{appointmentId,customerId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //取消预约详情
  async getCancelAppointmentDetail (id = '') {
    var result = null;
    try {
      result = await httpUtils.post('/server/cancel/appointment/check/detail',{id});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new CancelAppointmentCheckService()
